// https://grafikart.fr/tutoriels/scroll-defilement-1931

/**
 *
 * @param {HTMLElement} element
 * @return {number}
 */
function offsetTop(element, acc = 0){
    if( element.offsetParent!= null && !element.offsetParent ){
        return offsetTop(element.offsetParent, acc + element.offsetTop)
    } else {
        return acc + element.offsetTop;
    }
}

/**
 *
 * @param {number} number
 * @return {number}
 */
function range01(number){
    return Math.min(Math.max(number, 0), 1);
}

/**
 * @property {HTMLElement} element
 * @property {{y: number, variable: boolean}} options
 */
class Parallax {

    /**
     *
     * @param {HTMLElement} element
     */
    constructor(element){

        this.element = element;
        this.options = this.parseAttribute();

        this.onScroll = this.onScroll.bind(this);
        this.onIntersection = this.onIntersection.bind(this);
        this.onResize = this.onResize.bind(this);

        this.elementY = offsetTop(this.element) + this.element.offsetHeight / 2; // milieu de l'élément
        const observer = new IntersectionObserver(this.onIntersection);
        observer.observe(element);
        this.onScroll();
    }

    /**
     *
     * @return {({variable, y}&{y: number}&{r: number}&{s: number})|*}
     */
    parseAttribute(){
        const defaultOptions = {
            y: 0,
            x: 0,
            r: 0,
            variable: false
        };
        if( this.element.dataset.parallax.startsWith('{') ){
            return {
                ...defaultOptions,
                ...JSON.parse(this.element.dataset.parallax)
            };
        }

        return {
            ...defaultOptions,
            y: parseFloat(this.element.dataset.parallax)
        }
    }

    /**
     *
     * @param {IntersectionObserverEntry[]} entries
     */
    onIntersection(entries){
        for (const entry of entries ){
            if( entry.isIntersecting ){
                document.addEventListener("scroll", this.onScroll);
                window.addEventListener('resize', this.onResize);
                this.elementY = offsetTop(this.element) + this.element.offsetHeight / 2; // milieu de l'élément
            } else {
                document.removeEventListener("scroll", this.onScroll);
                window.removeEventListener("resize", this.onResize);
            }
        }
    }

    onResize(){
        this.elementY = offsetTop(this.element) + this.element.offsetHeight / 2; // milieu de l'élément
        this.onScroll();
    }

    onScroll(){
        window.requestAnimationFrame(() => {
            // const screenY = window.scrollY + window.innerHeight / 2; // milieu de la page
            let screenY = window.scrollY + this.elementY;
            let diffY = this.elementY - screenY;
            if( this.options.variable ){
                this.element.style.setProperty(
                    '--parallaxY',
                    `${translateY}px`
                )
            } else {
                let transform = ``;
                if( this.options.y ){
                    transform += `translateY(${diffY * -1 * this.options.y}px)`;
                }
                if( this.options.x ){
                    transform += ` translateX(${diffY * this.options.x}px)`;
                }
                if( this.options.r ){
                    let rmax = this.options.r.max;
                    let rmin = this.options.r.min;
                    let a = 1;
                    if( rmax < rmin ){
                        a = -1;
                    }
                    let r =  a * 1/200 * (Math.abs(diffY) / (1 - this.options.r.speed)) +  rmin;
                    if( rmax >= rmin && r >= rmax ){
                        r = rmax;
                    }
                    if( rmax <= rmin && r <= rmax ){
                        r = rmax;
                    }
                    transform += ` rotate(${r}deg)`;
                }
                if( this.options.s){
                    let s = 1 - (1 + diffY*(this.options.s)/10);
                    s = (s<=0.3)? 0.3 : s;
                    s = (s>1)? 1 : s;
                    transform += ` scale(${s})`;
                }
                if( this.options.y || this.options.x || this.options.r || this.options.s ){
                    if( this.options.limit ){
                        if( this.options.limit > Math.abs(diffY) ){
                            this.element.style.setProperty(
                                "transform",
                                transform
                            );
                        }
                    } else {
                        this.element.style.setProperty(
                            "transform",
                            transform
                        );
                    }

                }

                if( this.options.opacity ){
                    screenY = window.scrollY + window.innerHeight;
                    diffY = offsetTop(this.element) - screenY;
                    let opacity = 0;
                    if( this.options.opacity >= 0){
                        if( diffY > 0 ){
                            opacity = 0;
                        } else {
                            opacity = Math.abs(diffY) / (this.options.opacity*1000);
                        }
                        opacity = (opacity>1)? 1 : opacity;
                    } else {
                        opacity = 1;
                        if( diffY > 0 ){
                            opacity = 1;
                        } else {
                            opacity = 1 + (Math.abs(diffY) / (this.options.opacity*1000));
                            console.log(opacity);
                        }
                        opacity = (opacity<0)? 0 : opacity;
                    }

                    this.element.style.opacity = opacity;
                }


            }
        })

    }

    /**
     *
     * @returns {Parallax[]}
     */
    static bind(){
        return Array.from(document.querySelectorAll('[data-parallax]')).map(
            (element) => {
                return new Parallax(element);
            }
        )
    }
}
Parallax.bind();

